import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiNetlify,
  SiVisualstudiocode,
  SiPostman,
  SiHeroku,
  SiVercel,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiNetlify />
        <p style={{ fontSize: "15px" }}>Netlify</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <p style={{ fontSize: "15px" }}>VS Code</p>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
        <p style={{ fontSize: "15px" }}>Vercel</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiHeroku />
        <p style={{ fontSize: "15px" }}>Heroku</p>
      </Col>
    </Row>
  );
}

export default Toolstack;
